/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Execute_Output7Inputs */

const en_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live product URL`)
};

const ar_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط المنتج المباشر`)
};

const bn_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ প্রোডাক্ট URL`)
};

const de_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Produkt-URL`)
};

const es_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del producto en vivo`)
};

const fr_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL du produit en ligne`)
};

const pt_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do produto no ar`)
};

const zh_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线上产品 URL`)
};

const tr_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı ürün URL`)
};

const ru_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Живой URL продукта`)
};

const pl_svc_mvp_sprint_execute_output7 = /** @type {(inputs: Svc_Mvp_Sprint_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żywy URL produktu`)
};

/**
* | output |
* | --- |
* | "Live product URL" |
*
* @param {Svc_Mvp_Sprint_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_execute_output7 = /** @type {((inputs?: Svc_Mvp_Sprint_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "de") return de_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "es") return es_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_execute_output7(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_execute_output7(inputs)
	return en_svc_mvp_sprint_execute_output7(inputs)
});
export { svc_mvp_sprint_execute_output7 as "svc_mvp-sprint_EXECUTE_output" }